export interface Expedition {
  code: string
  courier: string
  company_name: string
  icon: string
  class?: string
  cargo?: boolean
}
export const REGULAR_EXPEDITIONS: Expedition[] = [
  {
    code: 'jne',
    courier: 'JNE Express',
    company_name: 'PT. Jalur Nugraha Ekakurir',
    icon: 'ka-icon:jne',
    class: 'text-[#25387B]',
    cargo: true
  },
  {
    code: 'jnt',
    courier: 'J&T Express',
    company_name: 'PT. Global Jet Express',
    class: 'text-[#ED3237]',
    icon: 'ka-icon:jnt'
  },
  {
    code: 'idx',
    courier: 'ID Express',
    company_name: 'PT. ID Express Logistik Indonesia',
    class: 'text-red-500',
    icon: 'ka-icon:idx',
    cargo: true
  },
  {
    code: 'sicepat',
    courier: 'Sicepat',
    company_name: 'PT. SiCepat Ekspres Indonesia',
    icon: 'ka-icon:sicepat',
    cargo: true
  },
  {
    code: 'paxel',
    courier: 'Paxel',
    company_name: 'PT. Paxel Algorita Unggul',
    class: 'text-[#5F51A1]',
    icon: 'ka-icon:paxel'
  },
  {
    code: 'lion',
    courier: 'Lion Parcel',
    company_name: 'PT. Lion Express',
    class: 'text-red-500',
    icon: 'ka-icon:lion'
  },
  {
    code: 'jtcargo',
    courier: 'J&T Cargo',
    company_name: 'PT. Global Jet Cargo',
    icon: 'ka-icon:jtcargo',
    class: 'text-[#008037]',
    cargo: true
  },
  {
    code: 'ncs',
    courier: 'NCS Kurir',
    company_name: 'PT. Nusantara Card Semesta',
    class: 'text-[#0D1B6F]',
    icon: 'ka-icon:ncs'
  },
  {
    code: 'sentral',
    courier: 'Sentral Cargo',
    company_name: 'PT. Aeronusa Intiraya',
    icon: 'ka-icon:sentral',
    cargo: true
  },
  {
    code: 'ninja',
    courier: 'Ninja Xpress',
    company_name: 'PT. Andiarta Muzizat',
    class: 'text-red-500',
    icon: 'ka-icon:ninja'
  },
  {
    code: 'anteraja',
    courier: 'AnterAja',
    company_name: 'PT. Tri Adi Bersama',
    icon: 'ka-icon:anteraja'
  },
  {
    code: 'posindonesia',
    courier: 'POS Indonesia',
    company_name: 'PT. Pos Indonesia',
    icon: 'ka-icon:posindonesia',
    class: 'text-[#182C61]',
    cargo: true
  },
  {
    code: 'tiki',
    courier: 'Tiki',
    company_name: 'PT. Citra Van Titipan Kilat',
    class: 'text-[#0632AD]',
    icon: 'ka-icon:tiki',
    cargo: true
  },
  {
    code: 'rpx',
    courier: 'RPX Holdings',
    company_name: 'PT. Antareja Prima Antaran',
    icon: 'ka-icon:rpx'
  },
  {
    code: 'sap',
    courier: 'SAPX Express',
    class: 'text-[#EE6825]',
    company_name: 'PT Satria Antaran Prima Tbk',
    icon: 'ka-icon:sap',
    cargo: true
  },
  {
    code: 'spx',
    courier: 'SPX Express',
    class: 'text-[#EE4D2D]',
    company_name: 'PT. Nusantara Ekspres Kilat',
    icon: 'ka-icon:spx'
  }
]

export const INSTANT_EXPEDITIONS: Expedition[] = [
  {
    code: 'gosend',
    courier: 'GoSend',
    company_name: 'PT. Paket Anak Bangsa',
    icon: 'ka-icon:gosend'
  },
  {
    code: 'grab',
    courier: 'Grab Express',
    company_name: 'PT. Solusi Pengiriman Indonesia',
    class: 'text-[#00AB4E]',
    icon: 'ka-icon:grab'
  },
  {
    code: 'borzo',
    courier: 'Borzo',
    company_name: 'PT. Incrin Indonesia Kurir',
    class: 'text-[#0048FF]',
    icon: 'ka-icon:borzo'
  }
]
